module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerloi01",
      "epub:type": "frontmatter",
      "id": "loi"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerloi01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "xi",
      "id": "pxi",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0007#toc"
    }
  }, [_vm._v("Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0013#fig1"
    }
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("1")])]), _vm._v("Advertisement for "), _c('i', [_vm._v("Manouche")]), _vm._v(": "), _c('i', [_vm._v("Les musiques d’aujourd’hui des Tsiganes d’Alsace")]), _vm._v(" (1984)")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0016#fig2"
    }
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("2")])]), _vm._v("Postcard for the 2004 Festival Gipsy Swing")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0016#fig3"
    }
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("3")])]), _vm._v("Ceremony at the grave of Django Reinhardt, Samois-sur-Seine, 1 July 2012")]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilie0016#fig4"
    }
  }, [_c('span', {
    staticClass: "fighn"
  }, [_vm._v("4")])]), _vm._v("Map of the Festival Jazz Manouche de Zillisheim")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7600ae8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lie-0009.vue
// module id = 78
// module chunks = 0